import { createReducer } from '@reduxjs/toolkit';

import * as footerActions from './footerActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'footer',
  isActive: false,

  content: '',
};

const footer = createReducer(initialState, (builder) => {
  builder
    .addCase(footerActions.footerUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(footerActions.footerUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    // Core builds Footer with SingleOrDefault, so a letter with no footer block answers with null
    // and emailsStore copies that straight into emails.footer. Opening the footer section then
    // dispatches null here, and destructuring it threw.
    .addCase(footerActions.footerStore, (state, { payload: data }) => {
      const {
        Content,
        Id,
        // SocialItems,
        // Style,
      } = data ?? {};

      return {
        ...state,

        error: null,
        requesting: false,

        id: Id ?? 0,

        content: Content ?? '',
      };
    })
    .addCase(footerActions.footerClear, () => ({ ...initialState }))

    .addCase(footerActions.footerUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(footerActions.footerUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(footerActions.footerUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(footerActions.footerUpdateContent, (state, { payload: content }) => ({ ...state, content }));
});

export default footer;
